/**
 * 콕핏 UI 버전 — 로그인 화면 우측 상단에 표시된다.
 *
 * 배포된 화면이 방금 고친 그 버전인지 눈으로 확인하기 위한 값이다. 브라우저가
 * 예전 번들을 캐시하고 있으면 여기 숫자가 그대로 남으므로, 옆의 새로고침 버튼을
 * 누른 뒤 숫자가 올라갔는지로 반영 여부를 판단할 수 있다.
 *
 * 규칙: UI 를 수정할 때마다 패치 자리를 1 올린다(0.1.0 → 0.1.1 → 0.1.2 ...).
 * package.json 의 version 과 같은 값으로 유지한다.
 */
export const UI_VERSION = "0.1.80";
